export const hiraganaExamplePhrases = [
    { label: "Ohayō (good morning)", value: "おはよう" },
    { label: "Ohayō gozaimasu (good morning, polite)", value: "おはようございます" },
    { label: "Genki desu ka? (how are you?)", value: "元気ですか？" },
    { label: "Arigatō (thank you)", value: "ありがとう" },
    { label: "Arigatō gozaimasu (thank you, polite)", value: "ありがとうございます" },
    { label: "Sumimasen (excuse me / sorry)", value: "すみません" },
    { label: "Hai (yes)", value: "はい" },
    { label: "Iie (no)", value: "いいえ" }
]

export const katakanaExamplePhrases = [
    { label: "Kōhī (coffee)", value: "コーヒー" },
    { label: "Pan (bread)", value: "パン" },
    { label: "Terebi (TV)", value: "テレビ" },
    { label: "Takushī (taxi)", value: "タクシー" },
    { label: "Hoteru (hotel)", value: "ホテル" },
    { label: "Kamera (camera)", value: "カメラ" },
    { label: "Amerika (America)", value: "アメリカ" },
    { label: "Intānetto (internet)", value: "インターネット" }
]
